import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { StepStatusState } from "./stepsInterfaces";

export const stepStatusSelector = (state: ReduxState): StepStatusState =>
  state.stepStatus;

export const useStepStatusSelector = (): StepStatusState =>
  useSelector(stepStatusSelector);
